<span
  [attr.id]="mElementId()"
  [ngStyle]="mElementStyles()"
  [ngClass]="mElementStyleClasses()"
  class="m-flex m-gap:2 m-text-body:small m-text-color:{{ level() }}"
>
  @if (textTemplate()) {
    <ng-container
      *ngTemplateOutlet="textTemplate().template; context: _context()"
    />
  } @else {
    {{ text() }}
  }
</span>
